var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5673 5.68571C15.5673 8.54996 13.2443 10.8714 10.3782 10.8714C7.51208 10.8714 5.1891 8.54996 5.1891 5.68571C5.1891 2.82147 7.51208 0.5 10.3782 0.5C13.2443 0.5 15.5673 2.82147 15.5673 5.68571ZM20.7564 22.5H0C0 17.7274 3.87107 13.8571 8.64849 13.8571H12.1079C16.8853 13.8571 20.7564 17.7274 20.7564 22.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.dc6c572b9dc1f569bb2913b57abe8e1c.svg";
export { ForwardRef as ReactComponent };